import React from 'react';
import { Logo } from './Logo';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-[rgba(0,0,0,0.1)] py-4">
        <div className="container flex items-center justify-between">
          <Link to="/">
            <Logo size="small" />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-[rgb(131,146,140)] hover:text-[rgb(0,55,32)] transition-colors">
            <ArrowLeft size={18} />
            <span>Torna alla Home</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container py-12 max-w-4xl">
        <h1 className="heading-1 mb-8">Cookie Policy</h1>
        <p className="text-[rgb(131,146,140)] mb-8">Ultimo aggiornamento: Gennaio 2025</p>

        <div className="prose prose-lg max-w-none text-[rgb(14,15,12)]">
          <section className="mb-8">
            <h2 className="heading-3 mb-4">1. Cosa Sono i Cookie</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              I cookie sono piccoli file di testo che vengono memorizzati sul tuo dispositivo quando visiti 
              il nostro sito web. Ci aiutano a fornire un'esperienza migliore e a comprendere come utilizzi i nostri servizi.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">2. Tipi di Cookie Utilizzati</h2>
            
            <h3 className="font-semibold text-[rgb(0,55,32)] mt-6 mb-2">Cookie Tecnici (Necessari)</h3>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Essenziali per il funzionamento del sito. Non possono essere disabilitati.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)] mb-4">
              <li>Gestione della sessione</li>
              <li>Preferenze di consenso cookie</li>
              <li>Sicurezza e autenticazione</li>
            </ul>

            <h3 className="font-semibold text-[rgb(0,55,32)] mt-6 mb-2">Cookie Analitici</h3>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Ci aiutano a capire come i visitatori interagiscono con il sito.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)] mb-4">
              <li>Statistiche di utilizzo anonime</li>
              <li>Pagine visitate e tempo di permanenza</li>
              <li>Origine del traffico</li>
            </ul>

            <h3 className="font-semibold text-[rgb(0,55,32)] mt-6 mb-2">Cookie di Preferenza</h3>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Memorizzano le tue preferenze per migliorare l'esperienza.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>Lingua preferita</li>
              <li>Impostazioni di visualizzazione</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">3. Gestione dei Cookie</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Puoi gestire le tue preferenze sui cookie in qualsiasi momento attraverso le impostazioni 
              del tuo browser o cliccando sul pulsante "Gestisci Cookie" nel banner.
            </p>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Nota: disabilitare alcuni cookie potrebbe influire sulla funzionalità del sito.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">4. Cookie di Terze Parti</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Potremmo utilizzare servizi di terze parti che impostano i propri cookie:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>Servizi di analisi (analytics)</li>
              <li>Mappe interattive</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">5. Contatti</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Per domande sui cookie, contattaci: 
              <a href="mailto:privacy@ezvi.it" className="text-[rgb(13,121,22)] hover:underline">privacy@ezvi.it</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default CookiePolicy;
